const Projects = {
    "ko": [
        {
            "site": 'CTK Cosmetics',
            "contents": [
                {
                    "title": '본사 사이트 개발',
                    "period": '2023.07 - 2023.07',
                    "languages": 'HTML, CSS, Javascript, jQuery, GSAP, PHP, Laravel',
                    "role": '프론트엔드(USER)',
                    "contribution": '50%',
                    "description": '· 소개 페이지(ABOUT US, OUR PLATFORM) 퍼블리싱 및 프론트 개발 <br/> · 문의하기 기능 및 이메일 작업'
                },
            ]
        },
        {
            "site": 'CTKCLIP',
            "contents": [
                {
                    "title": 'CTKCLIP 사이트 리뉴얼',
                    "period": '2022.04 - 2022.06',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '20%',
                    "description": '· 프로그래밍 언어 전환 (WEM → PHP, Laravel) <br/>· FAQ, MyPage(정보 수정 및 비밀번호 변경), MyClip(관심 상품 문의 및 샘플 요청) 페이지 개발 <br />'
                },
                {
                    "title": '문의 페이지 1차 리뉴얼',
                    "period": '2022.12 - 2022.12',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 퍼블리싱, 문의 내용 프론트엔드 개발 및 이메일 발송 기능'
                },
                {
                    "title": 'MOQ1000(소량 생산) 서비스 3차 개발',
                    "period": '2023.01 - 2023.02',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '50%',
                    "description": '· 퍼블리싱 및 주문 관리 기능'
                },
                {
                    "title": 'Custom Tooling 서비스 개발',
                    "period": '2023.03 - 2023.03',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 상품 상세 페이지 내 해당 서비스 퍼블리싱 및 문의 기능'
                },
                {
                    "title": '문의 페이지 2차 리뉴얼',
                    "period": '2023.04 - 2023.05',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 퍼블리싱 및 유저 문의 목록, 조회 및 재문의 기능 <br />· 상품 상세 페이지 내 해당 서비스 퍼블리싱 및 문의 기능'
                },
                {
                    "title": '블로그 개발',
                    "period": '2023.05 - 2023.06',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 퍼블리싱 및 목록, 조회 페이지 개발'
                },
                {
                    "title": 'Spotlight on 개발',
                    "period": '2023.05 - 2023.05',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· Spotlight On 페이지 퍼블리싱 및 목록, 조회 페이지 개발'
                },
                {
                    "title": '서비스 가이드 개발',
                    "period": '2023.07 - 2023.07',
                    "languages": 'HTML, CSS, Javascript, jQuery, GSAP, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· CTKCLIP 서비스 소개 페이지 퍼블리싱 및 프론트 개발'
                },
                {
                    "title": '마케팅 샘플 개발',
                    "period": '2023.08 - 2023.08',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 마케팅 샘플 서비스 소개 페이지 퍼블리싱 및 프론트 개발'
                },
                {
                    "title": '빠른 런칭 개발',
                    "period": '2023.09 - 2023.10',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 상품 상세 페이지 내 제형 색상, 해당 서비스 퍼블리싱 및 프론트 개발'
                },
                {
                    "title": 'CTKCLIP 메인 2차 리뉴얼',
                    "period": '2024.01 - 2024.02',
                    "languages": 'PHP, Laravel',
                    "role": '백엔드(DB, API)',
                    "contribution": '50%',
                    "description": '· 추가된 데이터를 위한 DB 필드 추가 및 API 개발'
                },
            ]
        },
        {
            "site": 'CTKCLIP for Partner',
            "contents": [
                {
                    "title": '파트너 사이트 개발',
                    "period": '2023.04 - 2023.04',
                    "languages": 'HTML, CSS, Javascript, vue.js',
                    "role": '프론트엔드, 백엔드(API)',
                    "contribution": '30%',
                    "description": '· 공통 스타일 퍼블리싱 <br />· 포뮬라 등록 INCI, 함량 정보 입력 기능 <br />· 파트너 정보 및 문의 관리 페이지 개발 <br />· 등록 제품 관리 기능'
                }
            ]
        },
        {
            "site": 'CTKCLIP for Admin',
            "contents": [
                {
                    "title": 'CTKCLIP 어드민 사이트 리뉴얼',
                    "period": '2022.04 - 2022.06',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '80%',
                    "description": '· 프로그래밍 언어 전환 (WEM → PHP, Laravel) <br/>· User, Category, GNB, TNB, Banner, PopUp 관리 기능'
                },
                {
                    "title": '성분 규제 스크리닝 기능 개발',
                    "period": '2022.08 - 2022.09',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": '프론트엔드. 백엔드(API)',
                    "contribution": '100%',
                    "description": '· 검토 정보 엑셀 업로드 및 스크리닝 결과 엑셀 다운로드 기능 <br />· 업로드 정보 및 외부 API(TheGoodFaceProject)를 연동한 결과를 DB 저장로 저장하는 API 개발'
                },
                {
                    "title": 'MOQ1000(소량 생산) 서비스 2차 리뉴얼',
                    "period": '2022.10 - 2022.11',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '50%',
                    "description": '· 생성 프로젝트 관리(요청 정보, 계약서, 결제 관리, ...) 기능 <br />· 1:1 문의. 아트워크 업로드 및 다운로드 기능'
                },
                {
                    "title": 'MOQ1000(소량 생산) 서비스 3차 개발',
                    "period": '2023.01 - 2023.02',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 프로젝트 주문 관리 기능'
                },
                {
                    "title": '성분 규제 검토 기능 개발',
                    "period": '2023.02 - 2023.04',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": '기획, 프론트엔드, 백엔드(DB, API)',
                    "contribution": '100%',
                    "description": '· INCI, 규제 코멘트, 처방 검토 관리 페이지 기획 <br />· INCI, 규제 코멘트, 처방 검토 관련 데이터베이스 설계 <br />· INCI, 규제 코멘트, 처방 검토 관리 기능 개발 <br />· 규제 코멘트 관련 목록, 조회, 추가, 수정, 삭제 API 개발 <br />· 처방 검토 관련 목록, 조회, 수정, 완료 기능 API 개발 <br />· 파트너 제품 규제 스크리닝 API 개발'
                },
                {
                    "title": '문의 페이지 2차 리뉴얼',
                    "period": '2023.04 - 2023.05',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 문의 관리, 재문의 답변, 임시 저장, 이메일 참조 기능'
                },
                {
                    "title": '블로그 개발',
                    "period": '2023.05 - 2023.06',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 목록, 조회, 추가, 수정 기능'
                },
                {
                    "title": '빠른 런칭 개발',
                    "period": '2023.09 - 2023.10',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 상품 상세 페이지 내 제형 색상, 해당 서비스 퍼블리싱 및 프론트 개발 <br />· 제형 색상 등록, 수정 기능 개발'
                },
                {
                    "title": '분할 배송 개발',
                    "period": '2023.12 - 2023.12',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 주문 관련 분할/일괄 처리 기능 개발'
                },
                {
                    "title": '어드민 사이트 메뉴 리뉴얼',
                    "period": '2024.01 - 2024.01',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": '프론트엔드, 백엔드(DB)',
                    "contribution": '100%',
                    "description": '· 어드민 메뉴 개편에 따른 리뉴얼 <br />· 전체 스타일 수정 및 메뉴 반환 로직 개발'
                },
                {
                    "title": 'CTKCLIP 메인 2차 리뉴얼',
                    "period": '2024.01 - 2024.02',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": '프론트엔드, 백엔드(DB, API)',
                    "contribution": '100%',
                    "description": '· 메인 개편에 따른 GNB 및 배너 관리 페이지 수정 <br />· 메인 상품 큐레이션 관리 페이지 개발 <br />· 추가된 데이터를 위한 DB 필드 추가 및 API 개발'
                },
            ]
        },
        {
            "site": '뮤지직',
            "contents": [
                {
                    "title": '사이트 개발 (PC)',
                    "period": '2024.12 - 2024.12',
                    "languages": 'HTML, CSS, Javascript, React',
                    "role": '프론트엔드',
                    "contribution": '80%',
                    "description": '· 소개 페이지(Home, About Us) 및 뮤지카드 페이지(목록, 상세) 퍼블리싱 및 프론트 개발'
                },
                {
                    "title": 'PC, 모바일 분리',
                    "period": '2025.01 - 2025.01',
                    "languages": 'HTML, CSS, Javascript, GSAP, React',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 전체 페이지 PC, 모바일 분리'
                },
                {
                    "title": '뮤지션 상세 페이지 커스터마이징',
                    "period": '2025.01 - 2025.01',
                    "languages": 'HTML, CSS, Javascript, React',
                    "role": '프론트엔드',
                    "contribution": '80%',
                    "description": '· 뮤지션 개별 커스터마이징(배경, 폰트) 적용'
                },
                {
                    "title": 'SEO 최적화',
                    "period": '2025.01 - 2025.01',
                    "languages": 'HTML, CSS, Javascript, React',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 메타 태그 동적 생성 (라이브러리: react-helmet-async) </br>· 사이트맵 동적 생성 (라이브러리: sitemap)'
                },
            ]
        },
        {
            "site": 'Arrow Design',
            "contents": [
                {
                    "title": 'Smart Sale',
                    "period": '2024.08 - 2024.08',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, WordPress',
                    "role": '프론트엔드, 백엔드',
                    "contribution": '80%',
                    "description": '· Designed and planned UI/UX. </br>· Developed functionality to manage user accounts.	</br>· Developed functionality to add, list, and view users\' products. </br>· Developed functionality for user-to-user communication. </br>· Developed functionality for user-to-user communication. </br>· Developed functionality for listing and filters. </br>· Developed functionality for order process by WooCommerce.'
                },
                {
                    "title": 'Precision Kitchens',
                    "period": '2024.09 - 2024.09',
                    "languages": 'WordPress, DIVI',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
                {
                    "title": 'Decorum',
                    "period": '2024.09 - 2024.09',
                    "languages": 'WordPress, DIVI',
                    "role": '프론트엔드',
                    "contribution": '80%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
                {
                    "title": 'ePosters',
                    "period": '2024.10 - 2024.10',
                    "languages": 'WordPress, DIVI',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
                {
                    "title": 'Soinia\'s Holistics Therapies',
                    "period": '2024.10 - 2024.10',
                    "languages": 'WordPress, DIVI',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
                {
                    "title": 'Plugin - Form Uploads',
                    "period": '2024.11 - 2024.11',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress',
                    "role": '프론트엔드, 백엔드',
                    "contribution": '80%',
                    "description": '· Designed and planned UI/UX. </br>· Developed functionality for CURD.'
                },
                {
                    "title": 'Hibernian Estates',
                    "period": '2024.11 - 2024.11',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress',
                    "role": '프론트엔드, 백엔드',
                    "contribution": '50%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI). </br>· Integration of daft.ie API for Real Estate Listings.'
                },
                {
                    "title": 'RTAI',
                    "period": '2024.11 - 2024.12',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress',
                    "role": '프론트엔드, 백엔드',
                    "contribution": '30%',
                    "description": '· Re-designed and planned UI/UX. </br>· Developed the functionalities to search and unsubscribe users. </br>· Developed the functionalities to create and download PDF files. </br>· Developed the functionalities to print a multi-purpose label.'
                },
                {
                    "title": 'Plugin - Custom Support',
                    "period": '2024.12 - 2024.12',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress',
                    "role": '프론트엔드, 백엔드',
                    "contribution": '80%',
                    "description": '· Designed and planned UI/UX. </br>· Developed functionality for customizing chat box. </br>· Developed functionality for chat service and managing history.'
                },
                {
                    "title": 'Gevents',
                    "period": '2024.12 - 2024.12',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress, DIVI',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
                {
                    "title": 'NTOI',
                    "period": '2024.12 - 2025.01',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress',
                    "role": '프론트엔드',
                    "contribution": '80%',
                    "description": '· Maintained and renewal CPD management pages.'
                },
                {
                    "title": 'Gutters Plus',
                    "period": '2025.01 - 2025.02',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress, DIVI',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
            ]
        },
        {
            "site": '페이버릿 미디엄',
            "contents": [
                {
                    "title": 'AiU 개발 및 배포',
                    "period": '2025.05 - 2025.06',
                    "languages": 'React, TailwindCSS, Kubernetes(Docker, OpenLens, ArgoCD)',
                    "role": '프론트엔드, DevOps',
                    "contribution": '50%',
                    "description": '· 모바일 퍼블리싱 및 프론트엔드 개발 </br>· 데스크탑 프론트엔드 개발 </br>· 운영 서버 배포'
                },
                {
                    "title": 'Speech To Text, Text To Speech 기능',
                    "period": '2025.07 - 2025.08',
                    "languages": 'React, TypeScript, TailwindCSS',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· TypeScript 전환 </br>· Speech To Text 퍼블리싱 및 프론트엔드 개발 </br>· Text To Speech 퍼블리싱 및 프론트엔드 개발'
                },
                {
                    "title": '대화 그룹 기능',
                    "period": '2025.07 - 2025.08',
                    "languages": 'React, TypeScript, TailwindCSS',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 대화 그룹 퍼블리싱 및 프론트엔드 개발'
                },
                {
                    "title": '앱 둘러보기 기능',
                    "period": '2025.09 - 2025.10',
                    "languages": 'React, TypeScript, TailwindCSS',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 앱 둘러보기 페이지 퍼블리싱 및 프론트엔드 개발'
                },
                {
                    "title": '사내 지식 활용 기능',
                    "period": '2025.10 - 2025.11',
                    "languages": 'React, TypeScript, TailwindCSS',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 사내 지식 컴포넌트 퍼블리싱 </br>· contentEditable 속성 적용 KeyDown 이벤트 적용 </br>· 사내 지식 기능 프론트엔드 개발'
                },
                {
                    "title": '응답 개인화/역할 기능',
                    "period": '2025.11 - 2025.11',
                    "languages": 'React, TypeScript, TailwindCSS',
                    "role": '프론트엔드',
                    "contribution": '100%',
                    "description": '· 응답 개인화/역할 컴포넌트 퍼블리싱 </br>· 응답 개인화/역할 기능 프론트엔드 개발 </br>· 응답 개인화/역할 관련 프롬프팅 관리'
                },
            ]
        },
    ],
    "en": [
        {
            "site": 'CTK Cosmetics',
            "contents": [
                {
                    "title": 'Development for HQ site',
                    "period": 'JUL 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, GSAP, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '50%',
                    "description": '· Developed UI & UX with GSAP <br />· Developed 2 pages(About us, Our platform) <br/> · Developed the function for sending an inquiry email.'
                },
            ]
        },
        {
            "site": 'CTKCLIP',
            "contents": [
                {
                    "title": 'Renewal for CTKCLIP',
                    "period": 'APR 2022 - JUN 2022',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '20%',
                    "description": '· Changed the programming languages(WEM → PHP, Laravel) <br />· UX and front-end Developed FAQ, MyPage(edit profile, change password), and MyClip(request samples and inquiry about interested products) page<br />'
                },
                {
                    "title": 'Renewal for Ask Us page (1st)',
                    "period": 'DEC 2022',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed UI & UX <br/>· Developed the function for saving an inquiry and sending an inquiry email.'
                },
                {
                    "title": 'Renewal the service for MOQ1000 (3rd)',
                    "period": 'JAN 2023 - FEB 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '50%',
                    "description": '· Developed UI & UX <br/>· Developed the function for user\'s order management'
                },
                {
                    "title": 'Development the service for Custom packaging',
                    "period": 'MAR 2023.03',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed UI & UX <br />· Developed the function for an inquiry about Custom Packaging service.'
                },
                {
                    "title": 'Renewal for Ask Us page (2nd)',
                    "period": 'APR 2023 - MAY 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed UI & UX <br />· Developed the page for listing and viewing user\'s inquiries. <br />· Developed the function for re-inquirying. <br />· Developed the function for inquirying on PDP.'
                },
                {
                    "title": 'Development for Blog page',
                    "period": 'MAY 2023 - JUN 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed UI & UX <br />· Developed the page for listing and viewing contents.'
                },
                {
                    "title": 'Development for Spotlight On page',
                    "period": 'MAY 2023.05',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed UI & UX <br />· Developed the page for listing and viewing contents.'
                },
                {
                    "title": 'Development for CTKCLIP Service Guide page',
                    "period": 'JUL 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, GSAP, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed UI & UX <br />· Developed the page for CTKCLIP service guide.'
                },
                {
                    "title": 'Development the service for Promotional Samples',
                    "period": 'AUG 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed UI & UX <br />· Developed the function for an inquiry about Promotional Samples service.'
                },
                {
                    "title": 'Development the service for Speed Market',
                    "period": 'SEP 2023 - OCT 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed UI & UX <br />· Developed the service for formulation colors.'
                },
                {
                    "title": 'Renewal for main page (2nd)',
                    "period": 'JAN 2024 - FEB 2024',
                    "languages": 'PHP, Laravel',
                    "role": 'Back-end(DB, API)',
                    "contribution": '50%',
                    "description": '· Developed the API for GNB, Banner, and product curation data.'
                },
            ]
        },
        {
            "site": 'CTKCLIP for Partner',
            "contents": [
                {
                    "title": 'Development for partner site',
                    "period": 'APR 2023',
                    "languages": 'HTML, CSS, Javascript, vue.js',
                    "role": 'Front-end, Back-end(API)',
                    "contribution": '30%',
                    "description": '· Structured common styles <br />· Developed the function for inserting INCI, percents. <br />· Developed the function for managing registered products. <br />· Developed pages for managing partner\'s information and inquiries.'
                }
            ]
        },
        {
            "site": 'CTKCLIP for Admin',
            "contents": [
                {
                    "title": 'Renewal for CTKCLIP admin site',
                    "period": 'APR 2022 - JUN 2022',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '80%',
                    "description": '· Changed the programming languages(WEM → PHP, Laravel) <br/>· Developed for the management page for User, Category, GNB, TNB, Banner, and PopUp'
                },
                {
                    "title": 'Developement the screening for cosmetc regulation',
                    "period": 'AUG 2022 - SEP 2022',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": 'Front-end, Back-end(API)',
                    "contribution": '100%',
                    "description": '· Developed the function for uploading excel file(product infromation) and downloading excel file(result). <br />· Developed the API for inserting the uploaded information and result linked external API(The Good Face Project) in DB.'
                },
                {
                    "title": 'Development by renewal the seirve for MOQ1000 (2nd)',
                    "period": 'OCT 2022 - NOV 2022',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '50%',
                    "description": '· Development for project management pages(products information, contract, payment, ...) 기능 <br />· Developed for inquiry by 1:1, uploading and downloading artworks for products'
                },
                {
                    "title": 'Development by renewal the service for MOQ1000 (3rd)',
                    "period": 'JAN 2023.01 - FEB 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed the function for management of project orders'
                },
                {
                    "title": 'Development the pages for regulation management',
                    "period": 'FEB 2023 - APR 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": 'Planning, Front-end, Back-end(DB, API)',
                    "contribution": '100%',
                    "description": '· Planned for management of INCI, Regulation comments, Formulation evaluation. <br />· Structured DB for INCI, Regulation comments, Formulation evaluation. <br />· Development for INCI, Regulation comments, and Formulation evaluation pages. <br />· Development the API for regulation comments(CRUD). <br />· Developed the API for listing, viewing, modifying, completing of formulation evaluation. <br />· Developed the API for regulation screening for partenr\'s products.'
                },
                {
                    "title": 'Renewal by ASK US page (3rd renewal)',
                    "period": 'APR 2023 - MAY 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed for inquiries management. <br />· Development the function for reply, temporaray save, and the email referencing feature.'
                },
                {
                    "title": 'Development for managing Blog',
                    "period": 'MAY 2023 - JUN 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed for listing, viewing, registering, and modifying blogs.'
                },
                {
                    "title": 'Development for managing Speed Market',
                    "period": 'DEP 2023 - OCT 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed the function for registering and modifying product formulation colors'
                },
                {
                    "title": 'Development for partial delivery',
                    "period": 'DEC 2023',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Developed the function for one/partial delivery for orders.'
                },
                {
                    "title": 'Renewal for Navigation',
                    "period": 'JAN 2024',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": 'UX developed, Front-end, Back-end(DB)',
                    "contribution": '100%',
                    "description": '· Renewal for improving admin menus <br />· Modified all style. <br />· Developed return of menus'
                },
                {
                    "title": 'Renewal by CTKCLIP main page (2nd renewal)',
                    "period": 'JAN 2024 - FEB 2024',
                    "languages": 'HTML, CSS, Javascript, jQuery, Bootstrap, PHP, Laravel',
                    "role": 'UX, Front-end, Back-end(DB, API)',
                    "contribution": '100%',
                    "description": '· Improved GNB & Banner management page <br />· Developed a [Product curation] menu for a main page. <br />· Modified DB and developed API for added data'
                },
            ]
        },
        {
            "site": 'MUSIZIC',
            "contents": [
                {
                    "title": 'Site Development (Desktop)',
                    "period": 'DEC 2024 - DEC 2024',
                    "languages": 'HTML, CSS, Javascript, React',
                    "role": 'Front-end',
                    "contribution": '80%',
                    "description": '· Developed Home, About Us, and Musicard Pages(List, Detail)'
                },
                {
                    "title": 'PC and mobile views',
                    "period": 'JAN 2025 - JAN 2025',
                    "languages": 'HTML, CSS, Javascript, GSAP, React',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Separated PC and mobile views and implemented responsive design for PC'
                },
                {
                    "title": 'Customizing for musician\'s detail page',
                    "period": 'JAN 2025 - JAN 2025',
                    "languages": 'HTML, CSS, Javascript, React',
                    "role": 'Front-end',
                    "contribution": '80%',
                    "description": '· Customized background and font style each musician'
                },
                {
                    "title": 'Optimiziation SEO',
                    "period": 'JAN 2025 - JAN 2025',
                    "languages": 'HTML, CSS, Javascript, React',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Creation dynamic meta tags (Library: react-helmet-async) </br>· Creation dynamic sitemap file (Library: sitemap)'
                },
            ]
        },
        {
            "site": 'Arrow Design',
            "contents": [
                {
                    "title": 'Smart Sale',
                    "period": '2024.08 - 2024.08',
                    "languages": 'HTML, CSS, Javascript, jQuery, PHP, WordPress',
                    "role": 'Front-end, Back-end',
                    "contribution": '80%',
                    "description": '· Designed and planned UI/UX. </br>· Developed functionality to manage user accounts.	</br>· Developed functionality to add, list, and view users\' products. </br>· Developed functionality for user-to-user communication. </br>· Developed functionality for user-to-user communication. </br>· Developed functionality for listing and filters. </br>· Developed functionality for order process by WooCommerce.'
                },
                {
                    "title": 'Precision Kitchens',
                    "period": '2024.09 - 2024.09',
                    "languages": 'WordPress, DIVI',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
                {
                    "title": 'Decorum',
                    "period": '2024.09 - 2024.09',
                    "languages": 'WordPress, DIVI',
                    "role": 'Front-end',
                    "contribution": '80%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
                {
                    "title": 'ePosters',
                    "period": '2024.10 - 2024.10',
                    "languages": 'WordPress, DIVI',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
                {
                    "title": 'Soinia\'s Holistics Therapies',
                    "period": '2024.10 - 2024.10',
                    "languages": 'WordPress, DIVI',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
                {
                    "title": 'Plugin - Form Uploads',
                    "period": '2024.11 - 2024.11',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress',
                    "role": 'Front-end, Back-end',
                    "contribution": '80%',
                    "description": '· Designed and planned UI/UX. </br>· Developed functionality for CURD.'
                },
                {
                    "title": 'Hibernian Estates',
                    "period": '2024.11 - 2024.11',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress',
                    "role": 'Front-end, Back-end',
                    "contribution": '50%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI). </br>· Integration of daft.ie API for Real Estate Listings.'
                },
                {
                    "title": 'RTAI',
                    "period": '2024.11 - 2024.12',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress',
                    "role": 'Front-end, Back-end',
                    "contribution": '30%',
                    "description": '· Re-designed and planned UI/UX. </br>· Developed the functionalities to search and unsubscribe users. </br>· Developed the functionalities to create and download PDF files. </br>· Developed the functionalities to print a multi-purpose label.'
                },
                {
                    "title": 'Plugin - Custom Support',
                    "period": '2024.12 - 2024.12',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress',
                    "role": 'Front-end, Back-end',
                    "contribution": '80%',
                    "description": '· Designed and planned UI/UX. </br>· Developed functionality for customizing chat box. </br>· Developed functionality for chat service and managing history.'
                },
                {
                    "title": 'Gevents',
                    "period": '2024.12 - 2024.12',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress, DIVI',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
                {
                    "title": 'NTOI',
                    "period": '2024.12 - 2025.01',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress',
                    "role": 'Front-end',
                    "contribution": '80%',
                    "description": '· Maintained and renewal CPD management pages.'
                },
                {
                    "title": 'Gutters Plus',
                    "period": '2025.01 - 2025.02',
                    "languages": 'HTML, CSS, Javascript, PHP, WordPress, DIVI',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Designed and planned UI/UX. </br>· Developed Front-end (using DIVI).'
                },
            ]
        },
        {
            "site": 'Favorite Medium',
            "contents": [
                {
                    "title": 'AiU Development & Deployment',
                    "period": 'MAY 2025 - JUN 2025',
                    "languages": 'React, TailwindCSS, Kubernetes(Docker, OpenLens, ArgoCD)',
                    "role": 'Front-end, DevOps',
                    "contribution": '50%',
                    "description": '· UI and frontend development for mobile and desktop platforms <br />· Deployment to production environments'
                },
                {
                    "title": 'Speech-to-Text (STT) & Text-to-Speech (TTS)',
                    "period": 'JUL 2025 - AUG 2025',
                    "languages": 'React, TypeScript, TailwindCSS',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Migration to TypeScript <br />· UI and frontend development for Speech-to-Text features <br />· UI and frontend development for Text-to-Speech features'
                },
                {
                    "title": 'Conversation Group Feature',
                    "period": 'JUL 2025 - AUG 2025',
                    "languages": 'React, TypeScript, TailwindCSS',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· UI and frontend development for conversation group functionality'
                },
                {
                    "title": 'App Exploration Feature',
                    "period": 'SEP 2025 - OCT 2025',
                    "languages": 'React, TypeScript, TailwindCSS',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· UI and frontend development for the App Exploration page'
                },
                {
                    "title": 'Internal Knowledge & Tool Interaction',
                    "period": 'OCT 2025 - NOC 2025',
                    "languages": 'React, TypeScript, TailwindCSS',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '· Implemented contentEditable with keydown event handling </br>· UI and frontend development enabling users to interact with internal knowledge and external tools'
                },
                {
                    "title": 'Response Personalization & Role Feature',
                    "period": 'NOV 2025',
                    "languages": 'React, TypeScript, TailwindCSS',
                    "role": 'Front-end',
                    "contribution": '100%',
                    "description": '·UI and frontend development for response personalization and role functionality </br>· Management of prompting related to personalization and role settings'
                },
            ]
        },
    ]
};

export default Projects;